<!--
 * @Description: 泵送费用
 * @Autor: wangwangwang
 * @Date: 2021-01-21 12:18:15
 * @LastEditors: 刘小二
 * @LastEditTime: 2023-04-03 08:58:25
-->
<template>
  <div>
    <el-dialog v-dialogDrag :visible.sync="dialog" width="1300px" :close-on-click-modal="false" :before-close="reset">
      <span slot="title" class="dialog-title">{{low.name}}:工程调价</span>
      <div>
        <div class="dialoginfo-title-bg">
          <div class="dialoginfo-title1">
            <template>
              <div v-for="item in checknavlist" :key="item.id" :class="checkindex == item.id ? 'active' : 'none'" @click="choose(item)">
                <div>{{ item.name }}</div>
              </div>
            </template>
          </div>
        </div>
        <div style="height: 530px; padding: 20px 0" class="scroll">
          <!-- 超高层增加费 -->
          <div v-show="checkindex == 3">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" border style="width: 100%" :data="fromDate3" tooltip-effect="dark">
              <el-table-column align="center" label="名称" width="220" prop="itemName"> </el-table-column>
              <el-table-column align="center" label="高度(米)" width="650">
                <template slot-scope="scope">
                  <div v-for="(item, index) in scope.row.children" :key="index" class="divdiv">
                    <div>
                      <div v-if="index == 0" class="itemdiv1">
                        <el-input v-model="item.leftInterval" :disabled="isLook" style="width: 80px"></el-input>
                        <el-select v-model="compare" size="mini" :disabled="isLook" style="width: 90px; margin-right: 10px" @change="save(item, 1, undefined, scope.row.children, $event, index, compare)">
                          <el-option :value="1" label="＜"></el-option>
                          <el-option :value="2" label="≤"></el-option>
                        </el-select>
                        <span style="padding: 5px; width: 60px">高度/臂长</span>
                        <el-select v-if="compare == 2" v-model="scope.row.children[0].intervalType" :disabled="isLook" size="mini" style="width: 90px; margin-right: 10px" @change="changeIntervalTypeList(scope.row.children)">
                          <el-option :value="2" label="＜"></el-option>
                          <el-option :value="4" label="≤"></el-option>
                        </el-select>
                        <el-select v-if="compare == 1" v-model="scope.row.children[0].intervalType" :disabled="isLook" size="mini" style="width: 90px; margin-right: 10px" @change="changeIntervalTypeList(scope.row.children)">
                          <el-option :value="1" label="＜"></el-option>
                          <el-option :value="3" label="≤"></el-option>
                        </el-select>
                        <!-- <span style="padding:20px">小于</span> -->
                        <el-input v-model="item.rightInterval" :disabled="isLook" type="Number" style="width: 120px" @change="save(item, 1, undefined, scope.row.children, $event, index)"></el-input>
                        <el-button v-if="scope.row.children.length < 2 && !isLook" size="mini" class="bottom_all" style="margin-left: 24px" @click="addfromDate3(scope.row, item, scope.row.children)">
                          <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                          添加
                        </el-button>
                      </div>
                      <div v-else-if="index == scope.row.children.length - 1" class="itemdiv1">
                        <span style="padding: 5px; width: 60px">高度/臂长</span>
                        <span style="padding: 20px; width: 28px">{{ scope.row.children[index - 1].intervalType == 1 || scope.row.children[index - 1].intervalType == 2 ? "≥" : "＞" }}</span>
                        <el-input v-model="item.leftInterval" disabled type="Number" style="width: 120px"></el-input>
                        <div>
                          <el-button v-if="!isLook" size="mini" style="margin-left: 24px" class="bottom_two" @click="delfromDate1(scope.row, index, item)">
                            <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                            删除
                          </el-button>
                          <el-button
                            v-if="scope.row.children.length > 1 && !isLook"
                            size="mini"
                            class="bottom_all"
                            style="margin-left: 12px"
                            @click="addfromDate3(scope.row, item, scope.row.children, scope.row.children[index - 1].intervalType)"
                          >
                            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                            添加
                          </el-button>
                        </div>
                      </div>
                      <div v-else class="itemdiv1">
                        <!-- <el-input v-model="scope.row.children[index-1].chargeStandard[1]" disabled style="width:100px"></el-input> -->
                        <el-input v-model="item.leftInterval" disabled style="width: 80px"></el-input>
                        <span style="padding: 5px; width: 28px">{{ scope.row.children[index - 1].intervalType == 1 || scope.row.children[index - 1].intervalType == 2 ? "≤" : "＜" }}</span>
                        <span style="padding: 5px; width: 60px">高度/臂长</span>
                        <el-select
                          v-if="scope.row.children[index - 1].intervalType == 1 || scope.row.children[index - 1].intervalType == 2"
                          v-model="item.intervalType"
                          :disabled="isLook"
                          size="mini"
                          style="width: 90px; margin-right: 10px"
                          @change="changeIntervalTypeList(scope.row.children), save(item, 1, undefined, scope.row.children, $event, index)"
                        >
                          <el-option :value="2" label="＜"></el-option>
                          <el-option :value="4" label="≤"></el-option>
                        </el-select>
                        <el-select
                          v-if="scope.row.children[index - 1].intervalType == 3 || scope.row.children[index - 1].intervalType == 4"
                          v-model="item.intervalType"
                          :disabled="isLook"
                          size="mini"
                          style="width: 90px; margin-right: 10px"
                          @change="changeIntervalTypeList(scope.row.children), save(item, 1, undefined, scope.row.children, $event, index)"
                        >
                          <el-option :value="1" label="＜"></el-option>
                          <el-option :value="3" label="≤"></el-option>
                        </el-select>
                        <el-input
                          v-model="item.rightInterval"
                          :disabled="isLook"
                          type="Number"
                          style="width: 80px"
                          @change="(scope.row.children[index + 1].leftInterval = item.rightInterval), save(item, 1, undefined, scope.row.children, $event, index)"
                        ></el-input>
                        <div>
                          <el-button v-if="!isLook" size="mini" style="margin-left: 24px" class="bottom_two" @click="delfromDate1(scope.row, index, item)">
                            <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                            删除
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="含税增加费（元）">
                <template slot-scope="scope">
                  <div v-for="(item, index) in scope.row.children" :key="index" class="divdiv">
                    <div>
                      <el-input
                        v-model="item.money"
                        v-input-limit="value => (String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/) ? String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/)[0] : '')"
                        :disabled="isLook"
                        type="Number"
                        style="width: 80px"
                        @change="save(item, 1, 2)"
                      ></el-input>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 小方量运输费用 -->
          <div v-show="checkindex == 2" style="margin-left: 50px">
            <div style="display: flex; flex-direction: row; align-items: center">
              <div>补差类型：</div>
              <el-select v-model="s_costFromData.type" :disabled="isLook" placeholder="请选择">
                <el-option v-for="item in dataTypeOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </div>
            <div v-show="s_costFromData.type == 1" style="margin-top: 20px">
              <span>小于</span>
              <el-input
                v-model="s_costFromData.square"
                v-input-limit="value => (String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/) ? String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/)[0] : '')"
                :disabled="isLook"
                style="width: 160px; margin: 0 20px"
                placeholder="请输入"
                type="Number"
              ></el-input>
              <span>方每车，不足部分按</span>
              <el-input
                v-model="s_costFromData.unitPrice"
                v-input-limit="value => (String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/) ? String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/)[0] : '')"
                :disabled="isLook"
                style="width: 160px; margin: 0 20px"
                placeholder="请输入"
                type="Number"
              >
              </el-input>
              <span>元/m³（含税），计算运输费用补差。</span>
            </div>
            <div v-show="s_costFromData.type == 2" style="margin-top: 20px">
              <span>小于</span>
              <el-input
                v-model="s_costFromData.square"
                v-input-limit="value => (String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/) ? String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/)[0] : '')"
                :disabled="isLook"
                style="width: 160px; margin: 0 20px"
                placeholder="请输入"
                type="Number"
              ></el-input>
              <span>方每车，不足部分按</span>
              <el-input
                v-model="s_costFromData.unitPrice"
                v-input-limit="value => (String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/) ? String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/)[0] : '')"
                :disabled="isLook"
                style="width: 160px; margin: 0 20px"
                placeholder="请输入"
                type="Number"
              >
              </el-input>
              <span>元/车（含税），计算运输费用补差。</span>
            </div>
            <div style="margin-top: 20px">
              <span style="display: inline-block; vertical-align: top">备注：</span>
              <div style="display: inline-block">
                <el-input v-model="s_costFromData.remark" v-input-limit="value => (value == '' ? ' ' : value)" :disabled="isLook" type="textarea" rows="5" cols="90"></el-input>
              </div>
            </div>
          </div>
          <!-- 信息调价 -->
          <ProductCostEng v-show="checkindex == 0" ref="productCostEng" :isLook="isLook" :engineeringId="low.id" @changeSetDialog="setDialog = true" @openProductInfo="openProductInfoFun"></ProductCostEng>
          <!-- 泵送费用 -->
          <pumpingCostsEnd v-show="checkindex == 1" ref="pumpingCostsEnd" :isLook="isLook" :engineeringId="low.id" :taxRate="low.taxRate + ''" @pumpingCostsSet="open" @pumpingCostsNote="open" />
          <!-- 特殊条款 -->
          <div v-show="checkindex == 4" style="margin-left: 50px">
            <div style="margin-top: 20px">
              <span style="display: inline-block; vertical-align: top">特殊条款：</span>
              <div style="display: inline-block">
                <el-input v-model="low.specialClause" v-input-limit="value => (value == '' ? ' ' : value)" :disabled="isLook" type="textarea" rows="5" cols="90"></el-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="reset">关 闭</el-button>
        <el-button v-show="checkindex == 2 && !isLook" class="bottom_all" style="margin-left: 24px" @click="saveSmallVolumeTransportationFun()">保 存</el-button>
        <el-button v-show="checkindex == 1 && !isLook" class="bottom_all" style="margin-left: 24px" @click="savePumpCost()">保 存</el-button>
        <el-button v-show="checkindex == 3 && !isLook" class="bottom_all" style="margin-left: 24px" @click="showSave()">保 存</el-button>
        <el-button v-show="checkindex == 4 && !isLook" class="bottom_all" style="margin-left: 24px" @click="submitSpecialTerms()">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 信息调价 -->
    <el-dialog v-dialogDrag :visible.sync="dialog1" width="1080px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">信息调价</span>
      <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="dialog1Data" tooltip-effect="dark">
        <el-table-column align="center" label="强度等级2">
          <el-table-column align="center" label="泵送">
            <el-table-column align="center" label="生效日期" prop="startTime" width="200">
              <template slot-scope="scope">
                <el-date-picker v-model="scope.row.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"> </el-date-picker>
              </template>
            </el-table-column>
            <el-table-column align="center" label="砼单价" prop="startTime" min-width="150">
              <template slot-scope="scope">
                <el-select v-model="scope.row.concretePriceMethod" placeholder="请选择">
                  <el-option :key="1" label="按C30信息价" :value="1"> </el-option>
                  <el-option :key="2" label="按标号信息价" :value="2"> </el-option>
                  <el-option :key="3" label="按砌筑砂浆M5价" :value="3"> </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column align="center" label="行政区" prop="startTime" width="200">
              <template slot-scope="scope">
                <el-cascader ref="address" v-model="scope.row.areaCode0" style="width: 150px" :options="treeData" filterable @change="administrativeDistrictsFun()"></el-cascader>
              </template>
            </el-table-column>
            <el-table-column align="center" label="对应关系" prop="startTime" width="220">
              <template slot-scope="scope">
                当月对应
                <el-select v-model="scope.row.correspondence" size="mini" placeholder="请选择" style="width: 100px">
                  <el-option :key="0" label="当期" :value="0"> </el-option>
                  <el-option :key="1" label="上一月" :value="1"> </el-option>
                  <el-option :key="2" label="上二月" :value="2"> </el-option>
                  <el-option :key="3" label="上三月" :value="3"> </el-option>
                  <el-option :key="4" label="上四月" :value="4"> </el-option>
                  <el-option :key="5" label="上五月" :value="5"> </el-option>
                  <el-option :key="6" label="上六月" :value="6"> </el-option>
                  <el-option :key="7" label="上七月" :value="7"> </el-option>
                  <el-option :key="8" label="上八月" :value="8"> </el-option>
                  <el-option :key="9" label="上九月" :value="9"> </el-option>
                  <el-option :key="10" label="上十月" :value="10"> </el-option>
                  <el-option :key="11" label="上十一月" :value="11"> </el-option>
                  <el-option :key="12" label="上十二月" :value="12"> </el-option>
                  <el-option :key="20" label="年平均" :value="20"> </el-option>
                </el-select>
                信息价
              </template>
            </el-table-column>
            <el-table-column align="center" label="价格方式" prop="startTime" width="120">
              <template slot-scope="scope">
                <el-select v-model="scope.row.pumpingPriceMode" placeholder="请选择">
                  <el-option :key="1" label="按比例" :value="1"> </el-option>
                  <el-option :key="2" label="按固定金额" :value="2"> </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column align="center" label="浮动" prop="startTime" width="120">
              <template slot-scope="scope">
                <el-select v-model="scope.row.pumpingFloat" placeholder="请选择">
                  <el-option :key="1" label="上浮" :value="1"> </el-option>
                  <el-option :key="2" label="下浮" :value="2"> </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column align="center" label="调整情况" width="150">
              <template slot-scope="scope">
                <el-input v-model="scope.row.pumpingAdjustBase" type="Number" style="width: 100%">
                  <template slot="append">{{ scope.row.pumpingPriceMode == 1 ? "%" : "元" }}</template>
                </el-input>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column align="center" label="非泵送">
            <el-table-column align="center" label="价格方式" prop="startTime" width="120">
              <template slot-scope="scope">
                <el-select v-model="scope.row.nonPumpingPriceMode" placeholder="请选择">
                  <el-option :key="1" label="按比例" :value="1"> </el-option>
                  <el-option :key="2" label="按固定金额" :value="2"> </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column align="center" label="浮动" prop="startTime" width="120">
              <template slot-scope="scope">
                <el-select v-model="scope.row.nonPumpingFloat" placeholder="请选择">
                  <el-option :key="1" label="上浮" :value="1"> </el-option>
                  <el-option :key="2" label="下浮" :value="2"> </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column align="center" label="调整情况" width="150">
              <template slot-scope="scope">
                <el-input v-model="scope.row.nonPumpingAdjustBase" type="Number" style="width: 100%">
                  <template slot="append">{{ scope.row.nonPumpingPriceMode == 1 ? "%" : "元" }}</template>
                </el-input>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table-column>
      </el-table>
      <span>上传附件:</span>
      <div style="padding-left: 42px"><FileComponent2 fileCode="priceFile" :files="files" @deleteFile="deleteFile" @uplodeSuccess="uplodeSuccess" /></div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="dialog1 = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="submit1">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 协商调价 -->
    <el-dialog v-dialogDrag :visible.sync="dialog2" width="800px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">泵送费用调价</span>
      <div class="dialoginfo">
        <el-form ref="low2" :inline="true" :rules="rules2" :model="low2" label-width="110px">
          <div>
            <el-form-item v-if="low2.item == 1" prop="code">
              <span slot="label">{{
                low2.itemType == 1 ? "强度等级：" : low2.itemType == 2 ? "性能等级：" : low2.itemType == 3 ? "材料要求：" : low2.itemType == 4 ? "特殊要求：" : low2.itemType == 5 ? "外加剂要求：" : "其他要求："
              }}</span>
              <div>{{ low2.itemName }}</div>
            </el-form-item>
            <el-form-item v-if="low2.item == 2" prop="code">
              <span slot="label">泵机类型：</span>
              <div>{{ low2.itemName }}</div>
            </el-form-item>
          </div>
          <div v-if="low2.item == 2">
            <el-form-item prop="code">
              <span slot="label">高度/臂长：</span>
              <div>{{ low2.chargeStandard[1] }}</div>
            </el-form-item>
          </div>
          <el-form-item prop="price">
            <span slot="label" style="color: #ff0000">调整价格：</span>
            <el-input
              v-model="low2.price"
              v-input-limit="value => (String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/) ? String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/)[0] : '')"
              placeholder="请输入"
              type="Number"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="startTime">
            <span slot="label" style="color: #ff0000">生效日期：</span>
            <el-date-picker v-model="low2.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"> </el-date-picker>
          </el-form-item>
          <div style="padding-left: 42px"><FileComponent2 fileCode="priceFile" :files="files2" @deleteFile="deleteFile2" @uplodeSuccess="uplodeSuccess2" /></div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="dialog2 = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="submit2">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 调价记录 -->
    <el-dialog v-dialogDrag :visible.sync="dialog3" width="880px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">调价记录</span>
      <div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="low3" tooltip-effect="dark">
          <el-table-column align="center" label="强度等级" prop="itemName"></el-table-column>
          <el-table-column align="center" label="调整价格" prop="price"></el-table-column>
          <el-table-column align="center" label="生效日期" prop="startTime"></el-table-column>
          <el-table-column align="center" label="调整时间" prop="createTime"></el-table-column>
          <el-table-column align="center" prop label="附件" width="120">
            <template slot-scope="scope">
              <el-button size="mini" class="bottom_all_two" @click="lookFile(scope)">查看</el-button>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button size="mini" class="bottom_two" @click="dellow3(scope.row, scope.$index)">
                <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="dialog3 = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 泵送调价记录 -->
    <el-dialog v-dialogDrag :visible.sync="dialog4" width="880px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">泵送调价记录</span>
      <!-- <div style="padding: 10px 0; display: flex">
        <div>泵机类型： {{ low2.itemName }}</div>
        <div v-if="dialog4" style="padding-left: 40px">高度/臂长： {{ low2.chargeStandard[1] }}</div>
      </div> -->
      <div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="low3" tooltip-effect="dark">
          <el-table-column align="center" label="调整价格" prop="price"></el-table-column>
          <el-table-column align="center" label="生效日期" prop="startTime"></el-table-column>
          <el-table-column align="center" prop label="附件" width="120">
            <template slot-scope="scope">
              <el-button size="mini" class="bottom_all_two" @click="lookFile(scope)">查看</el-button>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button v-if="!isLook" size="mini" class="bottom_two" style="margin-left: 24px" @click="dellow3(scope.row, scope.$index)">
                <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="dialog4 = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 查看附件 -->
    <LookFile :visible.sync="lookFileVisible" :config="lookFileConfig" />
    <!-- 设置产品价格 -->
    <SetProductDialog :setDialog.sync="setDialog" :engineeringId="low.id" :taxRate="low.taxRate + ''" @closeDialog="setDialog = false" @saveProdectFun="saveSetProdectFun" />
    <!-- 产品费用 - 特殊价格 -->
    <SpecialPriceDialog :specialPriceDialog.sync="specialPriceDialog" :isLook="isLook" :data="selectData" :engineeringInfo="low" @closeSpecialPriceDialog="(specialPriceDialog = false), saveSetProdectFun()" />
    <!-- 产品费用 - 信息价格 -->
    <InformationPriceDialog :informationPriceDialog.sync="informationPriceDialog" :isLook="isLook" :engineeringInfo="low" :data="selectData" @closeInformationPriceDialog="(informationPriceDialog = false), saveSetProdectFun()" />
    <!-- 产品费用 - 协商价格 -->
    <NegotiatePricesDialog :negotiatePricesDialog.sync="negotiatePricesDialog" :isLook="isLook" :data="selectData" :engineeringInfo="low" @closeNegotiatePricesDialog="(negotiatePricesDialog = false), saveSetProdectFun()" />
    <!-- 产品费用 - 产品价格 -->
    <ProductPriceDialog :productPriceDialog.sync="productPriceDialog" :isLook="isLook" :data="selectData" :engineeringInfo="low" @closeProductPriceDialog="(productPriceDialog = false), saveSetProdectFun()" />
  </div>
</template>
<script>
import FileComponent2 from "@/views/platform/ICPS/internetSales/components/fileComponent";
import LookFile from "@/components/File/LookFile";
// import { TreeSelect } from 'ant-design-vue';
import {
  queryPrising,
  savePrising,
  getDisClostDisAddCost,
  savePsavePumpCostAdjustumpCost,
  getRevisePriceProduction,
  delPumpCostAdjust,
  saveOrUpdateDisAddCost,
  queryPumpCostAdjust,
  updatePrising,
  updateMixRatio,
  saveSmallVolumeTransportation,
  querySmallVolumeTransportation,
} from "@/api/internetSales/engineeringControl.js";
import { setTimeout } from "timers";
import treeData from "@/views/platform/ICPS/basicConfig/address.js";
import ProductCostEng from "./productCostEng.vue";
import pumpingCostsEnd from "./pumpingCostsEnd.vue";
import SetProductDialog from "./setProductDialog.vue";
import SpecialPriceDialog from "./specialPriceDialog.vue";
import InformationPriceDialog from "./informationPriceDialog.vue";
import NegotiatePricesDialog from "./negotiatePricesDialog.vue";
import ProductPriceDialog from "./productPriceDialog.vue";
let loading = false;
export default {
  components: {
    // TreeSelect
    ProductCostEng,
    pumpingCostsEnd,
    SetProductDialog,
    FileComponent2,
    LookFile,
    SpecialPriceDialog,
    InformationPriceDialog,
    NegotiatePricesDialog,
    ProductPriceDialog,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    //是否为查看
    isLook: {
      type: Boolean,
      default: false,
    },
    low: {
      type: Object,
      default: new Object(),
    },
  },
  data() {
    return {
      compare: 1, //用于判断超高层第一个符号 1小于 2小于等于
      lookFileVisible: false,
      lookFileConfig: {},
      files: [],
      files2: [],
      treeData,
      checknavlist: [
        { name: "产品费用", id: 0 },
        { name: "泵送费用", id: 1 },
        { name: "超高层增加费", id: 3 },
        { name: "小方量运输费用", id: 2 },
        { name: "特殊条款", id: 4 },
      ],
      priceType: 1, //1产品价 2信息价
      checkindex: 0,
      fromDate2: {},
      fromDate1: [{ code: "", list: [{ code: "" }, { code: "" }, { code: "" }] }],
      fromDate3: [{ code: "", list: [{ code: "" }, { code: "" }, { code: "" }] }],
      fromDate01: [],
      fromDate02: [],
      fromDate03: [],
      fromDate04: [],
      fromDate05: [],
      fromDate06: [],
      fromDate07: [], //信息价强度列表
      dialog1: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      dialog5: false,
      low1: {
        id: "",
        engineeringId: "",
        riskFactor: "",
        riskAmount: "",
        adjustType: 1,
        adjustBase: 1,
        adjustMethod: 1,
        autoAdjust: 1,
        // areaCode0: '',
        areaCode: "",
      },
      rules1: {
        riskFactor: [{ required: true, message: "请输入风险系数", trigger: "change" }],
        riskAmount: [{ required: true, message: "请输入风险金额", trigger: "change" }],
        adjustType: [{ required: true, message: "请选择调价类型", trigger: "change" }],
        adjustBase: [{ required: true, message: "请选择调价基数", trigger: "change" }],
        adjustMethod: [{ required: true, message: "请选择调价方式", trigger: "change" }],
        areaCode: [{ required: true, message: "请选择行政区", trigger: "change" }],
      },
      low2: {
        itemName: "",
        price: "",
        startTime: "",
        costId: "",
        itemType: 1,
      },
      rules2: {
        price: [{ required: true, message: "请输入调整价格", trigger: "blur" }],
        startTime: [{ required: true, message: "请选择生效日期", trigger: "change" }],
      },
      low3: [],
      TreeSelectStypeNumber: 0,
      dialog1Data: [
        {
          areaCode: "", //区县编号
          areaCode0: [],
          concretePriceMethod: "", //砼单价，1按c30信息价，2按标号信息价
          correspondence: "", //对应关系:0当期；1上一月；2上二月；3上三月；4上四月；5上五月；6上六月；7上七月；8上八月；9上九月；10上十月；11上十一月；12上十二月；20年平均
          enclosureUrl: "", //附件url
          engineeringId: "", //工程id
          nonPumpingAdjustBase: "", //(非泵送)调整情况
          nonPumpingFloat: "", //(非泵送)浮动：1上浮；2下浮
          nonPumpingPriceMode: "", //(非泵送)价格方式：1按比例；2按固定金额
          pumpingAdjustBase: "", //(泵送)调整情况
          pumpingFloat: "", //(泵送)浮动：1上浮；2下浮
          pumpingPriceMode: "", //(泵送)价格方式：1按比例；2按固定金额
          startTime: "", //生效时间
        },
      ],
      // 设置产品调价
      setDialog: false,
      // 选择价格类型
      selectData: {},
      // 特殊价格弹窗
      specialPriceDialog: false,
      // 信息价格弹窗
      informationPriceDialog: false,
      // 协商价格弹窗
      negotiatePricesDialog: false,
      // 产品价格弹窗
      productPriceDialog: false,
      // 特殊条款
      specialClauseText: "",
      // 补差类型
      dataTypeOptions: [
        { value: 1, label: "方补" },
        { value: 2, label: "车补" },
      ],
      // 小方量补差
      s_costFromData: {
        dataType: 2,
        type: 1,
        unitPrice: "",
        square: "",
        engineeringid: "",
      },
    };
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.getAlldata();
        this.querySmallVolumeTransportationFun();
        setTimeout(() => {
          this.$refs.productCostEng.queryResordPageFun();
          this.$refs.pumpingCostsEnd.queryPumpList();
        }, 100);
      }
    },
  },
  mounted() {},
  beforeDestroy() {
    this.timer = null;
  },
  methods: {
    //超高层增加费符号切换 改变后续符号类型
    changeIntervalTypeList(list) {
      list.forEach((item, index) => {
        if (index > 0) {
          if (list[index - 1].intervalType == 1 || list[index - 1].intervalType == 2) {
            if (item.intervalType == 1) {
              item.intervalType = 2;
            }
            if (item.intervalType == 3) {
              item.intervalType = 4;
            }
          }
          if (list[index - 1].intervalType == 3 || list[index - 1].intervalType == 4) {
            if (item.intervalType == 2) {
              item.intervalType = 1;
            }
            if (item.intervalType == 4) {
              item.intervalType = 3;
            }
          }
        }
      });
    },
    showSave() {
      this.$message.success("保存成功！");
    },
    pumpingCostsSetFun() {
      this.dialog2 = true;
    },
    savePumpCost() {
      this.$refs.pumpingCostsEnd.savePumpCost(); //保存泵送费用数据
    },
    choose(item) {
      this.checkindex = item.id;
      if (this.checkindex == 1) {
        this.$refs.pumpingCostsEnd.getData(); //获取泵送费用数据
      }
    },
    // 保持特殊条款
    submitSpecialTerms() {
      updateMixRatio({ id: this.low.id, specialClause: this.low.specialClause }).then(res => {
        if (res.code == 1001) {
          this.$message({ message: "保存成功", type: "success" });
        }
      });
    },
    querySmallVolumeTransportationFun() {
      querySmallVolumeTransportation({ engineeringid: this.low.id }).then(res => {
        if (res.code == 1001) {
          this.s_costFromData = res.data ? res.data : this.$options.data().s_costFromData;
        }
      });
    },
    saveSmallVolumeTransportationFun() {
      this.s_costFromData.engineeringid = this.low.id;
      if (!this.s_costFromData.square || !this.s_costFromData.unitPrice) {
        this.$message.warning("补差数据不允许为空!");
        return;
      }
      saveSmallVolumeTransportation(this.s_costFromData).then(res => {
        if (res.code == 1001) {
          this.$message({ message: "保存成功", type: "success" });
        }
      });
    },
    // 查看费用设置
    openProductInfoFun(val) {
      console.log(" ---- ", val.priceType);
      this.selectData = val;
      switch (val.priceType) {
        case 1:
          this.informationPriceDialog = false;
          this.negotiatePricesDialog = false;
          this.productPriceDialog = true;
          this.specialPriceDialog = false;
          break;
        case 2:
          this.informationPriceDialog = false;
          this.negotiatePricesDialog = true;
          this.productPriceDialog = false;
          this.specialPriceDialog = false;
          break;
        case 3:
          this.informationPriceDialog = true;
          this.negotiatePricesDialog = false;
          this.productPriceDialog = false;
          this.specialPriceDialog = false;
          break;
        case 4:
          this.informationPriceDialog = false;
          this.negotiatePricesDialog = false;
          this.productPriceDialog = false;
          this.specialPriceDialog = true;
          break;
        default:
          break;
      }
    },
    saveSetProdectFun() {
      this.$refs.productCostEng.queryResordPageFun();
    },
    // 选择信息价
    selectPriceType() {
      if (this.priceType == 2) {
        queryPrising({ engineeringId: this.low.id }).then(res => {
          if (res.code == 1001 && res.data) {
            res.data.forEach(item => {
              item["areaCode0"] = item.areaCode ? JSON.parse(item.areaCode) : [];
            });
            this.fromDate07 = res.data;
            console.log(this.fromDate07);
          }
        });
      }
      this.$forceUpdate();
    },
    lookFile({ row }) {
      this.lookFileVisible = true;
      this.lookFileConfig = row;
    },
    uplodeSuccess2(data) {
      const params = {
        name: data.fileName,
        fileName: data.fileName,
        fileUrl: data.fileUrl,
        path: data.fileUrl,
        fileType: 1,
        type: 1,
        createTime: new Date().Format("yyyy-MM-dd hh:mm:ss"),
      };
      this.files2.push(params);
    },
    deleteFile2(index) {
      this.files2.splice(index, 1);
    },
    uplodeSuccess(data) {
      const params = {
        name: data.fileName,
        fileName: data.fileName,
        fileUrl: data.fileUrl,
        path: data.fileUrl,
        fileType: 1,
        type: 1,
        createTime: new Date().Format("yyyy-MM-dd hh:mm:ss"),
      };
      this.files.push(params);
    },
    deleteFile(index) {
      this.files.splice(index, 1);
    },
    getAlldata() {
      getDisClostDisAddCost({ id: this.low.id }).then(res => {
        if (res.data) {
          let data = res.data.filter(res => res.item == 2);
          let data3 = res.data.filter(res => res.item == 4);
          const setArr = (item, cur) => {
            cur.chargeStandard = cur.chargeStandard ? cur.chargeStandard.split(",") : [];
            if (item.some(res => res.itemId == cur.itemId)) {
              item[item.findIndex(res => res.itemId == cur.itemId)].children.push(cur);
            } else {
              let a = JSON.parse(JSON.stringify(cur));
              cur.children = [a];
              item.push(cur);
            }
            return item;
          };
          let arr = data.reduce(setArr, []);
          let arr3 = data3.reduce(setArr, []);
          this.fromDate1 = arr;
          console.log(this.fromDate1);
          this.fromDate3 = arr3;
          if (this.fromDate3.length == 0) {
            this.fromDate3 = [
              {
                engineeringId: res.data.length > 0 ? res.data[0].engineeringId : this.low.id,
                chargeStandard: [],
                dataType: 1,
                id: "",
                item: 4,
                sortNum: 0,
                intervalType: "",
                leftInterval: "",
                rightInterval: "",
                itemId: "",
                itemName: "高层",
                itemType: "",
                money: 0,
                children: [
                  {
                    engineeringId: res.data.length > 0 ? res.data[0].engineeringId : this.low.id,
                    chargeStandard: [],
                    dataType: 1,
                    id: "",
                    item: 4,
                    sortNum: 0,
                    intervalType: "",
                    leftInterval: "",
                    rightInterval: "",
                    itemId: "",
                    itemName: "高层",
                    itemType: "",
                    money: 0,
                  },
                ],
              },
            ];
          } else {
            this.compare = this.fromDate3[0].children[0].intervalType == 1 || this.fromDate3[0].children[0].intervalType == 3 ? 1 : 2;
          }
          console.log(JSON.parse(JSON.stringify(this.fromDate1)));
          this.fromDate01 = res.data.filter(res => res.item == 1 && res.itemType == 1).map(item => ({ ...item, dataType: 2, newMoney: item.newMoney ? (item.newMoney * 1).toFixed(2) : "" }));
          this.fromDate02 = res.data.filter(res => res.item == 1 && res.itemType == 2).map(item => ({ ...item, dataType: 2, newMoney: item.newMoney ? (item.newMoney * 1).toFixed(2) : "" }));
          this.fromDate03 = res.data.filter(res => res.item == 1 && res.itemType == 3).map(item => ({ ...item, dataType: 2, newMoney: item.newMoney ? (item.newMoney * 1).toFixed(2) : "" }));
          this.fromDate04 = res.data.filter(res => res.item == 1 && res.itemType == 4).map(item => ({ ...item, dataType: 2, newMoney: item.newMoney ? (item.newMoney * 1).toFixed(2) : "" }));
          this.fromDate05 = res.data.filter(res => res.item == 1 && res.itemType == 5).map(item => ({ ...item, dataType: 2, newMoney: item.newMoney ? (item.newMoney * 1).toFixed(2) : "" }));
          this.fromDate06 = res.data.filter(res => res.item == 1 && res.itemType == 6).map(item => ({ ...item, dataType: 2, newMoney: item.newMoney ? (item.newMoney * 1).toFixed(2) : "" }));
          this.fromDate2 = res.data.find(res => res.item == 3) || {};
          this.fromDate2.dataType = 2;
        }
      });
    },
    reset() {
      this.checkindex = 0;
      this.priceType = 1;
      this.s_costFromData = {
        dataType: 2,
        type: 1,
        unitPrice: "",
        square: "",
        engineeringid: "",
      };
      this.$emit("reset", "dialog1");
    },
    open(key, low) {
      console.log(key);
      this.getAlldata();
      this.timer = setTimeout(() => {
        if (key == "dialog1") {
          this.$data.dialog1Data = this.$options.data().dialog1Data;
          this[key] = true;
        }
        if (key == "dialog2") {
          this.low2.itemType = low.itemType;
          this.low2.itemName = low.itemName;
          this.low2.item = low.item;
          this.low2.chargeStandard = low.chargeStandard;
          this.low2.price = "";
          this.low2.startTime = "";
          this.low2.costId = low.id;
          this[key] = true;
          setTimeout(() => {
            this.$refs.low2.clearValidate();
          }, 10);
          return;
        }
        if (key == "dialog3") {
          getRevisePriceProduction({ engineeringId: this.low.id, itemId: low.itemId }).then(res => {
            this.low3 = res.data.data;
          });
          this[key] = true;
          return;
        }
        if (key == "dialog4") {
          queryPumpCostAdjust({ pumpingCostsId: low.id }).then(res => {
            this.low3 = res.data;
          });
          this[key] = true;
          return;
        }
      }, 200);
    },
    /**超高层*/
    addfromDate3(low, item, list, lastIntervalType) {
      if (loading) {
        return;
      }
      if (item.leftInterval === "" || item.intervalType === "" || item.rightInterval === "") {
        this.$message.warning("请将当前行数据填写完整!");
        return;
      }
      loading = true;
      console.log(JSON.parse(JSON.stringify(item)));
      let leftInterval = "";
      let num = item.rightInterval,
        chargeStandardArr = [];

      if (list.length >= 2) {
        num = item.leftInterval;
        item.leftInterval = String(Number(num));
        item.rightInterval = String(Number(num) + 1);
        leftInterval = String(Number(num) + 1);
        item.intervalType = lastIntervalType == 1 || lastIntervalType == 2 ? 2 : 3;
        //chargeStandardArr = [String(Number(num) + 1), '99999999']
      } else {
        //chargeStandardArr = [num, '99999999']
        leftInterval = num;
      }
      let intervalType = item.intervalType == 2 || item.intervalType == 4 ? 1 : 2;
      const data = {
        dataType: 1,
        chargeStandard: chargeStandardArr,
        engineeringId: low.engineeringId,
        item: low.item,
        itemId: low.itemId,
        itemName: low.itemName,
        itemType: low.itemType,
        leftInterval: leftInterval,
        rightInterval: "99999999",
        intervalType: intervalType,
        money: 0,
      };
      low.children.push(data);
      let arrList = JSON.parse(JSON.stringify(this.fromDate3));
      let arrData = [];
      arrList.forEach(v => {
        arrData = [...arrData, ...v.children];
      });
      arrData.forEach((v, k) => {
        v.chargeStandard = v.chargeStandard.join(",");
        v.sortNum = k;
      });
      console.log(arrData);
      saveOrUpdateDisAddCost(arrData).then(res => {
        loading = false;
        if (res.code == 1001) {
          this.getAlldata();
          // console.log(JSON.parse(JSON.stringify(low.children)))
        }
      });
    },
    /**泵送费用*/
    addfromDate1(low, item, list, lastIntervalType) {
      if (loading) {
        return;
      }
      loading = true;
      console.log(JSON.parse(JSON.stringify(item)));
      let leftInterval = "";
      let num = item.rightInterval,
        chargeStandardArr = [];

      if (list.length >= 2) {
        num = item.leftInterval;
        item.leftInterval = String(Number(num));
        item.rightInterval = String(Number(num) + 1);
        leftInterval = String(Number(num) + 1);
        item.intervalType = lastIntervalType == 1 || lastIntervalType == 2 ? 2 : 3;
        //chargeStandardArr = [String(Number(num) + 1), '99999999']
      } else {
        //chargeStandardArr = [num, '99999999']
        leftInterval = num;
      }
      let intervalType = item.intervalType == 2 || item.intervalType == 4 ? 1 : 2;
      const data = {
        dataType: 1,
        chargeStandard: chargeStandardArr,
        engineeringId: low.engineeringId,
        item: low.item,
        itemId: low.itemId,
        itemName: low.itemName,
        itemType: low.itemType,
        leftInterval: leftInterval,
        rightInterval: "99999999",
        intervalType: intervalType,
        money: 0,
      };
      low.children.push(data);
      let arrList = JSON.parse(JSON.stringify(this.fromDate1));
      let arrData = [];
      arrList.forEach(v => {
        arrData = [...arrData, ...v.children];
      });
      arrData.forEach((v, k) => {
        v.chargeStandard = v.chargeStandard.join(",");
        v.sortNum = k;
      });
      console.log(arrData);
      saveOrUpdateDisAddCost(arrData).then(res => {
        loading = false;
        if (res.code == 1001) {
          this.getAlldata();
          // console.log(JSON.parse(JSON.stringify(low.children)))
        }
      });
    },
    deletePriceInfo(row, index) {
      console.log(row.id);
      updatePrising({
        id: row.id,
      }).then(res => {
        if (res.code == 1001) {
          this.fromDate07.splice(index, 1);
        }
      });
    },
    delfromDate1(low, index, del) {
      let deldata = JSON.parse(JSON.stringify(del));
      deldata.dataType = 0;
      console.log(JSON.parse(JSON.stringify(deldata)));
      deldata.chargeStandard = deldata.chargeStandard.join(",");
      saveOrUpdateDisAddCost([deldata]).then(res => {
        if (res.code == 1001) {
          low.children.splice(index, 1);
        }
      });
    },
    administrativeDistrictsFun(value, label, extra) {
      console.log(value, label, extra); //区id和名字
      // console.log(extra.triggerNode.$parent.$options.propsData.title);//县名
      // console.log(extra.triggerNode.$parent.$options.propsData.value);//县id
      // console.log(extra.triggerNode.$parent.$parent.$options.propsData.title);//市名
      // console.log(extra.triggerNode.$parent.$parent.$options.propsData.value);//市id
      // this.low1.areaCode = JSON.stringify([extra.triggerNode.$parent.$parent.$options.propsData.value, extra.triggerNode.$parent.$options.propsData.value, value])
      this.$forceUpdate();
    },
    /**信息调价*/
    submit1() {
      const params = { ...this.dialog1Data[0], engineeringId: this.fromDate01[0].engineeringId, enclosureUrl: JSON.stringify(this.files) };
      params.areaCode = JSON.stringify(params.areaCode0);
      savePrising(params).then(res => {
        if (res.code == 1001) {
          this.$message({
            message: "保存成功",
            type: "success",
          });
          this.selectPriceType();
          this.dialog1 = false;
        }
      });
    },
    /**协商调价*/
    submit2() {
      if (!this.files2?.length) {
        return this.$message.warning("请上传附件文件");
      }
      this.$refs.low2.validate(valid => {
        if (valid) {
          const params = {
            pumpingCostsId: this.low2.costId,
            price: this.low2.price,
            startTime: this.low2.startTime,
            filePaths: JSON.stringify(this.files2),
          };
          savePsavePumpCostAdjustumpCost(params).then(res => {
            if (res.code == 1001) {
              this.$message({
                message: "保存成功",
                type: "success",
              });
              this.dialog2 = false;
              this.$refs.pumpingCostsEnd.getData(); //获取泵送费用数据
            }
          });
        } else {
          return false;
        }
      });
    },
    /**删除调价记录*/
    dellow3(low, index) {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          delPumpCostAdjust({ pumpingCostsId: low.id }).then(res => {
            if (res.code == 1001) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.low3.splice(index, 1);
              this.$refs.pumpingCostsEnd.getData(); //获取泵送费用数据
            }
          });
        })
        .catch(() => {});
    },
    changeIntervalType(index, compare) {
      let intervalType = this.fromDate3[0].children[index].intervalType;
      if (compare == 2 && intervalType == 1) {
        this.fromDate3[0].children[index].intervalType = 2;
      }
      if (compare == 2 && intervalType == 3) {
        this.fromDate3[0].children[index].intervalType = 4;
      }
      if (compare == 1 && intervalType == 2) {
        this.fromDate3[0].children[index].intervalType = 1;
      }
      if (compare == 1 && intervalType == 4) {
        this.fromDate3[0].children[index].intervalType = 3;
      }
    },
    /**保存修改信息*/
    save(row, type, dataType, indexList, value, index, compare, rowIndex, priceType) {
      if (compare) {
        this.changeIntervalType(index, compare);
      }
      if (row.leftInterval === "" || row.intervalType === "" || row.rightInterval === "") {
        row.rightInterval = "";
        this.$message.warning("请将当前行数据填写完整!");
        return;
      }
      if (row.chargeStandard === "") {
        row.chargeStandard = 0;
      }
      if (row.leftInterval === "") {
        row.leftInterval = 0;
      }
      if (row.money === "") {
        row.money = 0;
      }

      console.log(row, type, dataType, indexList, value);
      let arrData = [];
      if (type == 1 || type == 2) {
        let params = JSON.parse(JSON.stringify(row));
        //切换当前行符号，下一行intervalType跟着改变
        if (this.checkindex == 3) {
          if (this.fromDate3[0].children.length >= 3 && index < this.fromDate3[0].children.length - 1) {
            this.fromDate3[0].children.forEach((item, indexs) => {
              if (indexs >= index && indexs < this.fromDate3[0].children.length - 1) {
                if (item.intervalType == 3 || item.intervalType == 4) {
                  if (this.fromDate3[0].children[indexs + 1].intervalType == 2) {
                    this.fromDate3[0].children[indexs + 1].intervalType = 1;
                  }
                  if (this.fromDate3[0].children[indexs + 1].intervalType == 4) {
                    this.fromDate3[0].children[indexs + 1].intervalType = 3;
                  }
                }
                if (item.intervalType == 1 || item.intervalType == 2) {
                  if (this.fromDate3[0].children[indexs + 1].intervalType == 1) {
                    this.fromDate3[0].children[indexs + 1].intervalType = 2;
                  }
                  if (this.fromDate3[0].children[indexs + 1].intervalType == 3) {
                    this.fromDate3[0].children[indexs + 1].intervalType = 4;
                  }
                }
              }
            });
          }
        }
        if (this.checkindex == 1) {
          if (this.fromDate1[rowIndex]?.children.length >= 3 && index < this.fromDate1[rowIndex]?.children.length - 1) {
            this.fromDate1[rowIndex].children.forEach((item, indexs) => {
              if (indexs >= index && indexs < this.fromDate1[rowIndex].children.length - 1) {
                if (item.intervalType == 3 || item.intervalType == 4) {
                  if (this.fromDate1[rowIndex].children[indexs + 1].intervalType == 2) {
                    this.fromDate1[rowIndex].children[indexs + 1].intervalType = 1;
                  }
                  if (this.fromDate1[rowIndex].children[indexs + 1].intervalType == 4) {
                    this.fromDate1[rowIndex].children[indexs + 1].intervalType = 3;
                  }
                }
                if (item.intervalType == 1 || item.intervalType == 2) {
                  if (this.fromDate1[rowIndex].children[indexs + 1].intervalType == 1) {
                    this.fromDate1[rowIndex].children[indexs + 1].intervalType = 2;
                  }
                  if (this.fromDate1[rowIndex].children[indexs + 1].intervalType == 3) {
                    this.fromDate1[rowIndex].children[indexs + 1].intervalType = 4;
                  }
                }
              }
            });
          }
        }

        // 用于给不可点击输入框赋值的判断
        if (index > 0) {
          if (params.leftInterval) {
            params.leftInterval = indexList[index - 1].rightInterval;
          }
        } else if (index == 0 && indexList.length > 1) {
          indexList[index + 1].leftInterval = params.rightInterval;
        }
        // if (type === 1) {
        //    if( params.leftInterval){
        //    params.leftInterval = value
        //   }else{
        //     params.chargeStandard.splice(0,value)
        //   }
        // }
        if (type === 2) {
          params.rightInterval = 99999999;
        }
        // if (params.item == 2) {
        //   params.chargeStandard = params.chargeStandard.join(',')
        // }
        params.dataType = dataType || params.dataType;
        console.log(JSON.parse(JSON.stringify(params)));
        // 验证--------开始
        var arr1 = [];
        if (indexList) {
          arr1 = JSON.parse(JSON.stringify(indexList));
        }
        console.log(arr1);
        let type1 = false;
        if (arr1.length >= 3) {
          arr1.forEach((v, k) => {
            if (k > 0 && k < arr1.length - 1 && v.rightInterval - arr1[k - 1].rightInterval <= 0) {
              type1 = true;
            }
          });
        }
        if (type1) {
          this.$message({
            message: "区间值范围不正确，请检查！",
            type: "warning",
          });
          return;
        }
        // 验证--------结束
        if (!params.dataType) {
          params.dataType = 1;
        }
        let arrList = JSON.parse(JSON.stringify(this.fromDate1));
        let arrList3 = JSON.parse(JSON.stringify(this.fromDate3));
        arrList.forEach(v => {
          arrData = [...arrData, ...v.children];
        });
        arrList3.forEach(v => {
          arrData = [...arrData, ...v.children];
        });
        arrData.forEach((v, k) => {
          v.chargeStandard = v.chargeStandard.join(",");
          v.sortNum = k;
        });
        console.log(JSON.parse(JSON.stringify(arrData)));
      } else if (type == 3) {
        arrData = [this.fromDate2];
      } else {
        arrData = [row];
      }
      if (priceType == 2) {
        row.areaCode = JSON.stringify(row.areaCode0);
        savePrising(row);
      } else {
        saveOrUpdateDisAddCost(arrData); /* .then((res) => {
          if (res.code == 1001) {
            this.getAlldata()
          }
        }) */
      }
    },
    TreeSelectStypeFun() {
      if (this.TreeSelectStypeNumber === 0) {
        this.TreeSelectStypeNumber = 1;
        setTimeout(() => {
          const dom = document.body.lastChild;
          dom.style.zIndex = "10000";
        }, 1000);
      }
    },
  },
};
/** 
 * 产品费用
          <div v-show="checkindex == 8">
            <div>
              <el-select v-model="priceType" placeholder="请选择" @change="selectPriceType()">
                <el-option :key="1" label="产品价格" :value="1"> </el-option>
                <el-option :key="2" label="信息价格" :value="2"> </el-option>
              </el-select>
              <el-button v-if="priceType == 2" size="small" class="bottom_all" @click="open('dialog1')"> 信息调价 </el-button>
            </div>
            <div style="padding-top: 20px">
              <el-table v-show="priceType == 1" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="fromDate01" tooltip-effect="dark">
                <el-table-column align="center" label="强度等级" prop="itemName"></el-table-column>
                <el-table-column align="center" label="预计量（方）">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.chargeStandard" type="Number" style="width: 100%" @change="save(scope.row)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="初始合同价格">
                  <template slot-scope="scope">
                    <!-- input的正则限制 -->
                    <!-- v-input-limit="(value) => (String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/) ? String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/)[0] : '')"  -->
                    <el-input v-model="scope.row.money" style="width: 100%" type="Number" @change="save(scope.row)"> </el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="备注" prop="remark">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.remark" v-input-limit="value => (value == '' ? ' ' : value)" style="width: 100%" @change="save(scope.row)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="最新调整价格" prop="newMoney"></el-table-column>
                <el-table-column align="center" label="操作" width="250">
                  <template slot-scope="scope">
                    <el-button size="mini" class="bottom_all_two" @click="open('dialog2', scope.row)">协商调价</el-button>
                    <el-button size="mini" class="bottom_all_two" style="margin-left: 18px" @click="open('dialog3', scope.row)">调价记录</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-table v-show="priceType == 2" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="fromDate07" tooltip-effect="dark">
                <el-table-column align="center" label="强度等级">
                  <el-table-column align="center" label="泵送">
                    <el-table-column align="center" label="生效日期" prop="startTime" width="200"></el-table-column>
                    <el-table-column align="center" label="砼单价" prop="startTime" min-width="150">
                      <template slot-scope="scope">
                        <el-select v-model="scope.row.concretePriceMethod" placeholder="请选择" @change="save(scope.row,undefined,undefined,undefined,undefined,undefined,undefined,undefined,2)">
                          <el-option :key="1" label="按c30信息价" :value="1"> </el-option>
                          <el-option :key="2" label="按标号信息价" :value="2"> </el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" label="行政区" prop="startTime" width="200">
                      <template slot-scope="scope">
                        <el-cascader ref="address" v-model="scope.row.areaCode0" style="width: 150px" :options="treeData" filterable @change="administrativeDistrictsFun(),save(scope.row,undefined,undefined,undefined,undefined,undefined,undefined,undefined,2)"></el-cascader>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" label="对应关系" prop="startTime" width="220">
                      <template slot-scope="scope">
                        当月对应
                        <el-select v-model="scope.row.correspondence" size="mini" placeholder="请选择" style="width: 100px" @change="save(scope.row,undefined,undefined,undefined,undefined,undefined,undefined,undefined,2)">
                          <el-option :key="0" label="当期" :value="0"> </el-option>
                          <el-option :key="1" label="上一月" :value="1"> </el-option>
                          <el-option :key="2" label="上二月" :value="2"> </el-option>
                          <el-option :key="3" label="上三月" :value="3"> </el-option>
                          <el-option :key="4" label="上四月" :value="4"> </el-option>
                          <el-option :key="5" label="上五月" :value="5"> </el-option>
                          <el-option :key="6" label="上六月" :value="6"> </el-option>
                          <el-option :key="7" label="上七月" :value="7"> </el-option>
                          <el-option :key="8" label="上八月" :value="8"> </el-option>
                          <el-option :key="9" label="上九月" :value="9"> </el-option>
                          <el-option :key="10" label="上十月" :value="10"> </el-option>
                          <el-option :key="11" label="上十一月" :value="11"> </el-option>
                          <el-option :key="12" label="上十二月" :value="12"> </el-option>
                          <el-option :key="20" label="年平均" :value="20"> </el-option>
                        </el-select>
                        信息价
                      </template>
                    </el-table-column>
                    <el-table-column align="center" label="价格方式" prop="startTime" width="120">
                      <template slot-scope="scope">
                        <el-select v-model="scope.row.pumpingPriceMode" placeholder="请选择" @change="save(scope.row,undefined,undefined,undefined,undefined,undefined,undefined,undefined,2)">
                          <el-option :key="1" label="按比例" :value="1"> </el-option>
                          <el-option :key="2" label="按固定金额" :value="2"> </el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" label="浮动" prop="startTime" width="120">
                      <template slot-scope="scope">
                        <el-select v-model="scope.row.pumpingFloat" placeholder="请选择" @change="save(scope.row,undefined,undefined,undefined,undefined,undefined,undefined,undefined,2)">
                          <el-option :key="1" label="上浮" :value="1"> </el-option>
                          <el-option :key="2" label="下浮" :value="2"> </el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" label="调整情况" width="150">
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.pumpingAdjustBase" type="Number" style="width: 100%" @change="save(scope.row,undefined,undefined,undefined,undefined,undefined,undefined,undefined,2)">
                          <template slot="append">{{scope.row.pumpingPriceMode == 1 ? '%':'元'}}</template>
                        </el-input>
                      </template>
                    </el-table-column>
                  </el-table-column>
                  <el-table-column align="center" label="非泵送">
                    <el-table-column align="center" label="价格方式" prop="startTime" width="120">
                      <template slot-scope="scope">
                        <el-select v-model="scope.row.nonPumpingPriceMode" placeholder="请选择" @change="save(scope.row,undefined,undefined,undefined,undefined,undefined,undefined,undefined,2)">
                          <el-option :key="1" label="按比例" :value="1"> </el-option>
                          <el-option :key="2" label="按固定金额" :value="2"> </el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" label="浮动" prop="startTime" width="120">
                      <template slot-scope="scope">
                        <el-select v-model="scope.row.nonPumpingFloat" placeholder="请选择" @change="save(scope.row,undefined,undefined,undefined,undefined,undefined,undefined,undefined,2)">
                          <el-option :key="1" label="上浮" :value="1"> </el-option>
                          <el-option :key="2" label="下浮" :value="2"> </el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" label="调整情况" width="150">
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.nonPumpingAdjustBase" type="Number" style="width: 100%" @change="save(scope.row,undefined,undefined,undefined,undefined,undefined,undefined,undefined,2)">
                          <template slot="append">{{scope.row.nonPumpingPriceMode == 1 ? '%':'元'}}</template>
                        </el-input>
                      </template>
                    </el-table-column>
                  </el-table-column>
                  <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini" style="margin-left: 24px" class="bottom_two" @click="deletePriceInfo(scope.row, scope.$index)"> 删除 </el-button>
                    </template>
                  </el-table-column>
                </el-table-column>
              </el-table>
            </div>

            <div style="padding-top: 20px">
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="fromDate02" tooltip-effect="dark">
                <el-table-column align="center" label="性能等级" prop="itemName"></el-table-column>
                <el-table-column align="center" label="规格/类型">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.chargeStandard" style="width: 100%" @change="save(scope.row)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="初始合同价格">
                  <template slot-scope="scope">
                    <!-- input的正则限制 -->
                    <!--  v-input-limit="(value) => (String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/) ? String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/)[0] : '')"  -->
                    <el-input v-model="scope.row.money" style="width: 100%" type="Number" @change="save(scope.row)"> </el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="备注" prop="remark">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.remark" v-input-limit="value => (value == '' ? ' ' : value)" style="width: 100%" @change="save(scope.row)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="最新调整价格" prop="newMoney"></el-table-column>
                <el-table-column align="center" label="操作" width="250">
                  <template slot-scope="scope">
                    <el-button size="mini" class="bottom_all_two" @click="open('dialog2', scope.row)">协商调价</el-button>
                    <el-button size="mini" class="bottom_all_two" style="margin-left: 18px" @click="open('dialog3', scope.row)">调价记录</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div style="padding-top: 20px">
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="fromDate03" tooltip-effect="dark">
                <el-table-column align="center" label="材料要求" prop="itemName"></el-table-column>
                <el-table-column align="center" label="预计量（方）">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.chargeStandard" type="Number" style="width: 100%" @change="save(scope.row)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="初始合同价格">
                  <template slot-scope="scope">
                    <!-- input的正则限制 -->
                    <!--  v-input-limit="(value) => (String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/) ? String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/)[0] : '')"  -->
                    <el-input v-model="scope.row.money" style="width: 100%" type="Number" @change="save(scope.row)"> </el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="备注" prop="remark">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.remark" v-input-limit="value => (value == '' ? ' ' : value)" style="width: 100%" @change="save(scope.row)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="最新调整价格" prop="newMoney"></el-table-column>
                <el-table-column align="center" label="操作" width="250">
                  <template slot-scope="scope">
                    <el-button size="mini" class="bottom_all_two" @click="open('dialog2', scope.row)">协商调价</el-button>
                    <el-button size="mini" class="bottom_all_two" style="margin-left: 18px" @click="open('dialog3', scope.row)">调价记录</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div style="padding-top: 20px">
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="fromDate04" tooltip-effect="dark">
                <el-table-column align="center" label="特殊要求" prop="itemName"></el-table-column>
                <el-table-column align="center" label="预计量（方）">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.chargeStandard" type="Number" style="width: 100%" @change="save(scope.row)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="初始合同价格">
                  <template slot-scope="scope">
                    <!-- input的限制 -->
                    <!--  v-input-limit="(value) => (String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/) ? String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/)[0] : '')"  -->
                    <el-input v-model="scope.row.money" style="width: 100%" type="Number" @change="save(scope.row)"> </el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="备注" prop="remark">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.remark" v-input-limit="value => (value == '' ? ' ' : value)" style="width: 100%" @change="save(scope.row)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="最新调整价格" prop="newMoney"></el-table-column>
                <el-table-column align="center" label="操作" width="250">
                  <template slot-scope="scope">
                    <el-button size="mini" class="bottom_all_two" @click="open('dialog2', scope.row)">协商调价</el-button>
                    <el-button size="mini" class="bottom_all_two" style="margin-left: 18px" @click="open('dialog3', scope.row)">调价记录</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div style="padding-top: 20px">
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="fromDate05" tooltip-effect="dark">
                <el-table-column align="center" label="外加剂要求" prop="itemName"></el-table-column>
                <el-table-column align="center" label="预计量（方）">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.chargeStandard" type="Number" style="width: 100%" @change="save(scope.row)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="初始合同价格">
                  <template slot-scope="scope">
                    <!-- input的正则限制 -->
                    <!-- v-input-limit="(value) => (String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/) ? String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/)[0] : '')" -->
                    <el-input v-model="scope.row.money" style="width: 100%" type="Number" @change="save(scope.row)"> </el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="备注" prop="remark">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.remark" v-input-limit="value => (value == '' ? ' ' : value)" style="width: 100%" @change="save(scope.row)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="最新调整价格" prop="newMoney"></el-table-column>
                <el-table-column align="center" label="操作" width="250">
                  <template slot-scope="scope">
                    <el-button size="mini" class="bottom_all_two" @click="open('dialog2', scope.row)">协商调价</el-button>
                    <el-button size="mini" class="bottom_all_two" style="margin-left: 18px" @click="open('dialog3', scope.row)">调价记录</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div style="padding-top: 20px">
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="fromDate06" tooltip-effect="dark">
                <el-table-column align="center" label="其他要求" prop="itemName"></el-table-column>
                <el-table-column align="center" label="预计量（方）">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.chargeStandard" type="Number" style="width: 100%" @change="save(scope.row)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="初始合同价格">
                  <template slot-scope="scope">
                    <!-- v-input-limit="(value) => (String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/) ? String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/)[0] : '')"  -->
                    <el-input v-model="scope.row.money" style="width: 100%" type="Number" @change="save(scope.row)"> </el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="备注" prop="remark">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.remark" v-input-limit="value => (value == '' ? ' ' : value)" style="width: 100%" @change="save(scope.row)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="最新调整价格" prop="newMoney"></el-table-column>
                <el-table-column align="center" label="操作" width="250">
                  <template slot-scope="scope">
                    <el-button size="mini" class="bottom_all_two" @click="open('dialog2', scope.row)">协商调价</el-button>
                    <el-button size="mini" class="bottom_all_two" style="margin-left: 18px" @click="open('dialog3', scope.row)">调价记录</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

 * **/

/**
 * 泵送费用
 

          <div v-show="checkindex == 11">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" border style="width: 100%" :data="fromDate1" tooltip-effect="dark">
              <el-table-column align="center" label="泵机类型" width="220" prop="itemName"> </el-table-column>
              <el-table-column align="center" label="高度/臂长 (米)" width="550">
                <template slot-scope="scope">
                  <div v-for="(item, index) in scope.row.children" :key="index" class="divdiv">
                    <div>
                      <div v-if="index == 0" class="itemdiv1">
                        <span style="padding: 5px; width: 60px">高度/臂长</span>
                        <el-select v-model="scope.row.children[0].intervalType" size="mini" style="width: 90px; margin-right: 10px" @change="save(item, 1, undefined, scope.row.children, $event, index, undefined, scope.$index)">
                          <el-option :value="2" label="＜"></el-option>
                          <el-option :value="4" label="≤"></el-option>
                        </el-select>
                        <!-- <span style="padding:20px">小于</span> -->
                        <el-input v-model="item.rightInterval" type="Number" style="width: 120px" @change="save(item, 1, undefined, scope.row.children, $event, index, undefined, scope.$index)"></el-input>
                        <el-button v-if="scope.row.children.length < 2" size="mini" class="bottom_all" style="margin-left: 24px" @click="addfromDate1(scope.row, item, scope.row.children)">
                          <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                          添加
                        </el-button>
                      </div>
                      <div v-else-if="index == scope.row.children.length - 1" class="itemdiv1">
                        <span style="padding: 5px; width: 60px">高度/臂长</span>
                        <span style="padding: 20px; width: 28px">{{ scope.row.children[index - 1].intervalType == 1 || scope.row.children[index - 1].intervalType == 2 ? "≥" : "＞" }}</span>
                        <el-input v-model="item.leftInterval" disabled type="Number" style="width: 120px"></el-input>
                        <div>
                          <el-button size="mini" style="margin-left: 24px" class="bottom_two" @click="delfromDate1(scope.row, index, item)">
                            <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                            删除
                          </el-button>
                          <el-button
                            v-if="scope.row.children.length > 1"
                            size="mini"
                            class="bottom_all"
                            style="margin-left: 12px"
                            @click="addfromDate1(scope.row, item, scope.row.children, scope.row.children[index - 1].intervalType)"
                          >
                            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                            添加
                          </el-button>
                        </div>
                      </div>
                      <div v-else class="itemdiv1">
                        <!-- <el-input v-model="scope.row.children[index-1].chargeStandard[1]" disabled style="width:100px"></el-input> -->
                        <el-input v-model="item.leftInterval" disabled style="width: 80px"></el-input>
                        <span style="padding: 5px; width: 28px">{{ scope.row.children[index - 1].intervalType == 1 || scope.row.children[index - 1].intervalType == 2 ? "≤" : "＜" }}</span>
                        <span style="padding: 5px; width: 60px">高度/臂长</span>
                        <el-select
                          v-if="scope.row.children[index - 1].intervalType == 1 || scope.row.children[index - 1].intervalType == 2"
                          v-model="item.intervalType"
                          size="mini"
                          style="width: 90px; margin-right: 10px"
                          @change="save(item, 1, undefined, scope.row.children, $event, index, undefined, scope.$index)"
                        >
                          <el-option :value="2" label="＜"></el-option>
                          <el-option :value="4" label="≤"></el-option>
                        </el-select>
                        <el-select
                          v-if="scope.row.children[index - 1].intervalType == 3 || scope.row.children[index - 1].intervalType == 4"
                          v-model="item.intervalType"
                          size="mini"
                          style="width: 90px; margin-right: 10px"
                          @change="save(item, 1, undefined, scope.row.children, $event, index, undefined, scope.$index)"
                        >
                          <el-option :value="1" label="＜"></el-option>
                          <el-option :value="3" label="≤"></el-option>
                        </el-select>
                        <el-input
                          v-model="item.rightInterval"
                          type="Number"
                          style="width: 80px"
                          @change="(scope.row.children[index + 1].leftInterval = item.rightInterval), save(item, 1, undefined, scope.row.children, $event, index)"
                        ></el-input>
                        <div>
                          <el-button size="mini" style="margin-left: 24px" class="bottom_two" @click="delfromDate1(scope.row, index, item)">
                            <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                            删除
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="初始合同价格(元/方)" width="150">
                <template slot-scope="scope">
                  <div v-for="(item, index) in scope.row.children" :key="index" class="divdiv">
                    <div>
                      <el-input
                        v-model="item.money"
                        v-input-limit="value => (String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/) ? String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/)[0] : '')"
                        type="Number"
                        style="width: 80px"
                        @change="save(item, 1, 2)"
                      ></el-input>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="最新调整价格(元/方)" width="100">
                <template slot-scope="scope">
                  <div v-for="(item, index) in scope.row.children" :key="index" class="divdiv">
                    <span>{{ item.newMoney }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                  <div v-for="(item, index) in scope.row.children" :key="index" class="divdiv">
                    <div>
                      <el-button size="mini" class="bottom_all_two" style="margin-left: 0px" @click="open('dialog2', item)">调 价</el-button>
                      <el-button size="mini" class="bottom_all_two" style="margin-left: 10px" @click="open('dialog4', item)">查看记录</el-button>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

 * **/
</script>

<style lang="scss" scoped>
.divdiv {
  height: 52px;
  padding-left: 25px;
  display: flex;
  align-items: center;
}
.divdiv + .divdiv {
  border-top: 1px solid #dcdfe6;
}
.itemdiv1 {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

